import * as types from '../mutation-types'
import api from '@/api/projects'
import router from "@/router";

// initial state
const state = {
    project: [],
    loaded: false,
}

const getters = {
    project: state => state.project,
    projectLoaded: state => state.loaded,
}

const actions = {
    getProject({ commit }, payload) {
        commit(types.SET_PROJECT_LOADED, false );
        api.getProjects(payload, (response) => {
            if(!response._embedded.Project[0]) {
                router.push('/404')
            }
            commit(types.SET_PROJECT, response._embedded.Project[0] );
            commit(types.SET_PROJECT_LOADED, true );
        })
    },
    cleanProject({commit}) {
        commit(types.SET_PROJECT_LOADED, false );
        commit(types.SET_PROJECT, {} );
    }
}

const mutations = {
    [types.SET_PROJECT] (state, project ) {
        state.project = project
    },
    [types.SET_PROJECT_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


